import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Divider, Input} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const filterSectionConfig = (configuration = [], section) => {
  return configuration.filter((process) => process.transport === section);
};

class DaysSection extends Component {
  handleValueChange(step, event, data) {
    const {section} = this.props;
    this.props.updateValueForOrderTrackingConfig({
      section,
      step,
      'field': data.name,
      'value': data.value,
    });
  }

  handleToggleChange(step, event, data) {
    const {section} = this.props;
    this.props.updateValueForOrderTrackingConfig({
      section,
      step,
      'field': data.name,
      'value': data.checked,
    });
  }

  renderValues() {
    const {configuration} = this.props;

    return configuration.map((process, index) => {
      return (
        <Grid.Row key={index}>
          <Grid.Column width='4' textAlign='left'>
            {process.status}
          </Grid.Column>
          <Grid.Column width='8' textAlign='left'>
            {process.description}
          </Grid.Column>
          <Grid.Column width='4' textAlign='left'>
            <Input
              fluid
              min={0}
              size='mini'
              name='days'
              type='number'
              value={process.days || ''}
              onChange={this.handleValueChange.bind(this, process.status)}
            />
          </Grid.Column>
        </Grid.Row>
      );
    });
  }

  render() {
    const {transport} = this.props;

    return (
      <Card raised className='tracking-section'>
        <h3>{transport}</h3>
        Dias para los pedidos de repuestos
        <Divider />
        <Grid>
          <Grid.Row>
            <Grid.Column width='4' textAlign='left'>
              <strong>Proceso</strong>
            </Grid.Column>
            <Grid.Column width='8' textAlign='left'>
              <strong>Descripción</strong>
            </Grid.Column>
            <Grid.Column width='4' textAlign='left'>
              <strong>Días</strong>
            </Grid.Column>
          </Grid.Row>
          {this.renderValues()}
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {configuration} = state.providerOrderTrackingConfig;
  const sectionValues = filterSectionConfig(configuration, ownProps.section);

  return {
    'configuration': sectionValues,
  };
};

const {updateValueForOrderTrackingConfig} = Actions;

export default connect(mapStateToProps, {
  updateValueForOrderTrackingConfig,
})(DaysSection);
